import { Box, Grid2, Typography } from '@mui/material';
import { useGetSkillFourTeachersCourses, useGetSkillToSchoolCourses } from '../../assets/nodeApi/getApi/getSchoolApi';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import CustomDivider from '../../shared/utils/CustomDivider';
import { GridChildren } from '../../shared/utils/LingtBlueContainer';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import SchoolMyCourseCard from '../../shared/components/school/SchoolMyCourseCard';
import { Grid_Gap, Website_Url } from '../../shared/constants';
import { formatDateToDDMMYYYY } from '../../shared/formatter';
import { useProcessedCourses } from '../../shared/hook/useProcessedCourses';

const SchoolExploreCourses = () => {
  // const { data: SkilltoSchoolCourses, isLoading: isLoadingSkilltoSchool } = useGetSkillToSchoolCourses();
  // const { data: SkillFourTeachersCourses, isLoading: isLoadingSkillFourTeachers } = useGetSkillFourTeachersCourses();
    const { skill2SchoolCourses, upSkill4TeacherCourses, isLoading } = useProcessedCourses()
  return (
    <>
      <NormalContainerWithHeader headerText={"Skill 2 School"}>
        <Grid2 container spacing={Grid_Gap}>
          {isLoading ? (
            [...Array(9)].map((_, index) => (
              <GridChildren index={index} key={index}>
                <SkeletonCom />
              </GridChildren>
            ))
          ) : skill2SchoolCourses?.length === 0 ? (
            <Box textAlign="center" width="100%">
              <Typography variant="h6">Course not found.</Typography>
            </Box>
          ) : (
            skill2SchoolCourses?.map((item, index) => (
              <GridChildren index={index} key={index}>
                <SchoolMyCourseCard
                  item={item}
                  buttonText={"Purchase Now"}
                  buttonAction={() => { window.location.href = `${Website_Url}CourseDetail/${item?.slug}/Skill 2 School` }}
                  details={[
                    { label: "From", value: formatDateToDDMMYYYY(item?.start_date) },
                    { label: "to", value: formatDateToDDMMYYYY(item?.end_date) },
                  ]}
                  title={item?.title}
                />
              </GridChildren>
            ))
          )}
        </Grid2>
      </NormalContainerWithHeader>
      <CustomDivider />
      <NormalContainerWithHeader headerText={"Upskill 4 Teachers"}>
        <Grid2 container spacing={Grid_Gap}>
          {isLoading ? (
            [...Array(9)].map((_, index) => (
              <GridChildren index={index} key={index}>
                <SkeletonCom />
              </GridChildren>
            ))
          ) : upSkill4TeacherCourses?.length === 0 ? (
            <Box textAlign="center" width="100%">
              <Typography variant="h6">Course not found.</Typography>
            </Box>
          ) : (
            upSkill4TeacherCourses?.map((item, index) => (
              <GridChildren index={index} key={index}>
                <SchoolMyCourseCard
                  buttonText={"Purchase Now"}
                  buttonAction={() => { window.location.href = `${Website_Url}CourseDetail/${item?.slug}/Upskill 4 Teacher` }}
                  item={item}
                  title={item?.title}
                  details={[
                    { label: "From", value: formatDateToDDMMYYYY(item?.start_date) },
                    { label: "to", value: formatDateToDDMMYYYY(item?.end_date) },
                  ]}
                />
              </GridChildren>
            ))
          )}
        </Grid2>
      </NormalContainerWithHeader>
    </>

  )
}

export default SchoolExploreCourses
